import { CalendarDays } from 'lucide-react'
import { Button } from '@/components/common/Button'

interface AdjustValidityButtonProps {
  selectedCount: number
  onClick: () => void
  disabled?: boolean
}

export function AdjustValidityButton({ selectedCount, onClick, disabled }: AdjustValidityButtonProps) {
  if (selectedCount === 0) return null

  return (
    <Button
      variant="secondary"
      size="sm"
      onClick={onClick}
      disabled={disabled}
      className="flex items-center gap-2"
      title={`Gültigkeit für ${selectedCount} Lehrer anpassen`}
    >
      <CalendarDays className="h-4 w-4" />
      <span>Datum anpassen</span>
      <span className="bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full text-xs font-medium">
        {selectedCount}
      </span>
    </Button>
  )
}
